import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import LazyImage from 'helpers/LazyImage';
import {format24Hour, formatDateDay, formatDateShort} from 'lib/helpers/globalize-helper';
import {formatDuration} from '../common';

function showELAL(operatingCode, dep, arr, flightNumber, hasTechnicalStop) {
  const existInRoute = ((dep, arr, depArray, arrArray) => depArray.includes(dep) && arrArray.includes(arr));
  const depAirportCodes = ['TLV'];
  const arrAirportCodes = ['BER', 'BUD', 'KBP', 'LCA', 'PRG'];
  const existInRoute1 = existInRoute(dep, arr, depAirportCodes, arrAirportCodes);
  const existInRoute2 = existInRoute(dep, arr, arrAirportCodes, depAirportCodes);
  return (
    operatingCode === 'LY' &&
    flightNumber.length === 4 &&
    !hasTechnicalStop &&
    (existInRoute1 || existInRoute2)
  );
}

const SegmentDetails = ({
  segment,
  depAirport,
  arrAirport,
  hasTechnicalStop,
  translations
}) => {
  const {
    isFirst,
    isLast,
    duration,
    isNextDayArrival,
    isMidnightArrival,
    isDepDifferentFromPreviousArr,
    transport: {type: transportationType, equipment, number,
      carriers: {operating, marketing}},
    services: {bookingClass, cabinClass}
  } = segment;

  const {
    airline,
    airlineCodeShareInfo,
    cabinClass: cabinClassTitle,
    transportationType: transportationTypeTitle,
    codeShare,
    aircraftType: aircraftTypeTitle,
    time,
    nextDayArrival,
    afterMidnightArrival,
    depDifferentAirportPreviousArr
  } = translations;
  const isFlight = transportationType === 'flight';

  return (
    <div className={`grid result-details-${transportationType}`}>
      <div className="grid-item-3-10 text-right">
        <div className={`${(isFirst && !hasTechnicalStop) ? 'h4' : 'h5'}`}>
          {format24Hour(depAirport.datetime)}
        </div>
        <div className="text-small text-muted">
          <span className="d-none d-sm-inline">
            {formatDateDay(depAirport.datetime)}&nbsp;
          </span>
          {formatDateShort(depAirport.datetime)}
        </div>
      </div>
      <div className="grid-item-7-10 result-details-dep">
        <div className="float-right d-xs-none">
          <LazyImage imgClass="airline-logo" src={marketing.logo} title="logo" alt="logo" />
        </div>
        <div className={`${(isFirst && !hasTechnicalStop) ? 'h4' : 'h5'}`}>{depAirport.city}</div>
        <p className="text-small leading-normal text-left" dir="auto">
          {`${depAirport.name} (${depAirport.code}), ${depAirport.country}`}<br/>
          <span className="text-muted">
            {duration && <div><b>Duration:</b> {formatDuration(moment.duration(duration, 'minutes'), time)}<br/></div>}
            <b>{airline}:</b> {marketing.name} / {marketing.code} {number} <br/>
            { showELAL(operating.code, depAirport.code, arrAirport.code, number, hasTechnicalStop) &&
              <span><b>{airlineCodeShareInfo}</b><br/></span> }
            {bookingClass && <span><b>{cabinClassTitle}:</b> {cabinClass.name}&nbsp;({bookingClass})<br/></span>}
            {equipment &&
              <span>
                <b>{isFlight ? aircraftTypeTitle : transportationTypeTitle}:</b>&nbsp;{equipment}<br/>
              </span>
            }
            {operating.code !== marketing.code &&
              <span><b>{codeShare}:</b> {operating.name}&nbsp;({operating.code}) <br/></span>
            }
            {
              isDepDifferentFromPreviousArr && 
              <span className="differentAirport-badge">{depDifferentAirportPreviousArr}</span>
            }
          </span>
        </p>
      </div>
      <div className="grid-item-3-10 text-right">
        <div className={`${isLast && !hasTechnicalStop ? 'h4' : 'h5'}`}>
          {format24Hour(arrAirport.datetime)}
        </div>
        <div className="text-small text-muted">
          <span className="d-none d-sm-inline">
            {formatDateDay(arrAirport.datetime)}&nbsp;
          </span>
          {formatDateShort(arrAirport.datetime)}
        </div>
      </div>
      <div className={`grid-item-7-10 result-details-arr ${(isLast && !hasTechnicalStop) && 'last'}`}>
        <div className={`${(isLast && !hasTechnicalStop) ? 'h4' : 'h5'}`}>{arrAirport.city}</div>
        <p className="text-small leading-normal">
          {`${arrAirport.name} (${arrAirport.code}), ${arrAirport.country}`}
          <br/>
          {
            isMidnightArrival &&
              <span className="nextDay-badge">{afterMidnightArrival}</span>
          }
          {
            isNextDayArrival &&
              <span className="nextDay-badge">{nextDayArrival}</span>
          }
        </p>
      </div>
    </div>
  );
};

SegmentDetails.propTypes = {
  segment: PropTypes.object.isRequired,
  translations: PropTypes.object.isRequired,
  depAirport: PropTypes.object.isRequired,
  arrAirport: PropTypes.object.isRequired,
  hasTechnicalStop: PropTypes.bool.isRequired
};

export default SegmentDetails;
